import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const displaySchemaApi = createApi({
  reducerPath: 'displaySchemaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '',
  }),
  endpoints: builder => ({
    getDisplaySchema: builder.query({
      query: schema => `${schema}`,
      transformResponse: response => response?.data,
    }),
  }),
});

export const { useGetDisplaySchemaQuery } = displaySchemaApi;
